module.exports = __webpack_public_path__ + "img/DE01321.96a60342.png";